"use client";

import type { ChildrenProp } from "@huub-web/ui";
import type { FC } from "react";
import { Route, Routes } from "react-router-dom";

import { useAppController } from "../../hooks";
import { generateRoutesFromNavigationState } from "../../utils/generateRoutesFromNavigationState";
import { AppPageLayout } from "../AppPageLayout/AppPageLayout";
import { AppScreen } from "../AppScreen/AppScreen";

type AppRoutesProps = ChildrenProp & {
  debug?: boolean;
};

/**
 * The main routing component of the application.
 * Generates routes dynamically from the backend navigationState.
 * Uses a layout route so the persistent layout (navigation, header, etc.)
 * stays mounted across route changes -- only the screen content animates.
 */
export const AppRoutes: FC<AppRoutesProps> = ({ children }) => {
  const { navigationState } = useAppController();

  const routeConfigs =
    !navigationState || navigationState.length === 0
      ? []
      : generateRoutesFromNavigationState(navigationState);

  return (
    <Routes>
      <Route element={<AppPageLayout>{children}</AppPageLayout>}>
        {routeConfigs.map((config) => (
          <Route
            key={config.path}
            path={config.path}
            element={
              <AppScreen
                screenType={config.screenType}
                endpoint={config.endpoint}
              />
            }
          />
        ))}
        <Route
          path=":section/interior-designer"
          element={<AppScreen screenType="interior-designer" />}
        />
        <Route
          path=":section/:property/interior-designer"
          element={<AppScreen screenType="interior-designer" />}
        />
        <Route path="*" element={<AppScreen screenType="templates" />} />
      </Route>
    </Routes>
  );
};
